<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" size="small" class="mr10" @click="add"
        >新增模板</el-button
        >
        <el-button type="primary" size="small" class="mr10" @click="addBatch"
        >批量新增模板</el-button
        >
      </div>
      <div>
        <el-input
          size="small"
          clearable
          placeholder="请输入模板名称"
          class="mr10 ipt"
          v-model.trim="searchCondition.templateName"
        ></el-input>
        <el-select
          class="mr10"
          size="small"
          style="width: 250px"
          clearable
          filterable
          v-model="searchCondition.templateType"
          placeholder="请选择模板类型"
        >
         <el-option
            v-for="item in allMerchant"
            :key="item.itemValue"
            :label="item.itemText"
            :value="item.itemValue"
          ></el-option>
          <!-- <el-option label="小票日期" value="receiptDate"></el-option>
          <el-option label="小票号" value="receiptSn"></el-option>
          <el-option label="小票时间戳" value="receiptDateStr"></el-option>
          <el-option label="门店名称" value="shopName"></el-option>
          <el-option label="商品数量" value="number"></el-option>
          <el-option label="小票去重模板管理" value="receiptRepeat"></el-option>
          <el-option label="导购名称" value="guiderName"></el-option>
          <el-option label="小票号日期" value="receiptSnDate"></el-option> -->
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
        border
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="templateName"
          label="模板名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="templateType"
          label="模板类型"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.templateType === 'receiptDate'">小票日期</div>
            <div v-else-if="scope.row.templateType === 'receiptSn'">小票号</div>
            <div v-else-if="scope.row.templateType === 'receiptDateStr'">
              小票时间戳
            </div>
            <div v-else-if="scope.row.templateType === 'shopName'">
              门店名称
            </div>
            <div v-else-if="scope.row.templateType === 'number'">商品数量</div>
            <div v-else-if="scope.row.templateType === 'receiptRepeat'">
              小票去重模板管理
            </div>
            <div v-else-if="scope.row.templateType === 'guiderName'">
              导购名称
            </div>
            <div v-else-if="scope.row.templateType === 'receiptSnDate'">
              小票号日期
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="description"
          label="模板描述"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="bindShopNum"
          label="绑定门店数"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="storeCode"
          label="小票示例"
        >
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.templateImg"
              :preview-src-list="[scope.row.templateImg]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="enableState"
          label="是否启用"
        >
          <template slot-scope="scope">
            <div
              :class="scope.row.enableState === 'yes' ? 'success' : 'danger'"
            >
              {{ scope.row.enableState === "yes" ? "启用" : "禁用" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="150"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="edit(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="small"
              type="text"
              @click="del(scope.row)"
              :disabled="scope.row.bindShopNum > 0"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
      <el-dialog
        :title="title"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="1000px"
        :before-close="cancel"
      >
        <div class="flex">
          <el-form
            v-if="dialogVisible"
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            :inline="false"
            label-width="130px"
          >
            <el-form-item label="模板名称" prop="templateName">
              <el-input
                style="width: 350px"
                maxlength="150"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.templateName"
                placeholder="请输入模板名称"
              ></el-input>
            </el-form-item>

            <el-form-item label="模板类型" prop="templateType">
              <el-select
                class="mr10"
                size="small"
                style="width: 350px"
                v-model="ruleForm.templateType"
                placeholder="请选择模板类型"
                @change="typeChange"
              >
              <el-option
            v-for="item in allMerchant"
            :key="item.itemValue"
            :label="item.itemText"
            :value="item.itemValue"
          >
           <span style="float: left">{{ item.itemText }}</span>
           <span style="color: #c5c6c7; font-size: 13px;margin-left:10px">{{ item.regularMatchDesc }}</span>
          </el-option>
                <!-- <el-option label="小票日期" value="receiptDate"></el-option>
                <el-option label="小票号" value="receiptSn"></el-option>
                <el-option
                  label="小票时间戳"
                  value="receiptDateStr"
                ></el-option>
                <el-option label="门店名称" value="shopName"></el-option>
                <el-option label="商品数量" value="number"></el-option>
                <el-option
                  label="小票去重模板管理"
                  value="receiptRepeat"
                ></el-option>
                <el-option label="导购名称" value="guiderName"></el-option>
                <el-option label="小票号日期" value="receiptSnDate"></el-option> -->
              </el-select>
              <div style="color: #c5c6c7; font-size: 13px;">{{regularMatchDesc}}</div>
            </el-form-item>
            <el-form-item
              label="是否允许自动通过"
              prop="autoEnable"
              v-if="ruleForm.templateType === 'number'"
            >
              <el-switch
                size="mini"
                v-model="ruleForm.autoEnable"
                active-text="允许"
                inactive-text="禁止"
                active-color="#2fc348"
                inactive-color="#ff0000"
                active-value="yes"
                inactive-value="no"
              ></el-switch>
              <span class="form-red">数量匹配时是否允许自动通过</span>
            </el-form-item>
            <el-form-item label="预览结果" v-if="showResult">
              {{ preview }}
            </el-form-item>
            <div v-if="ruleForm.templateType !== 'receiptRepeat'">
              <div
                v-if="
                  ruleForm.templateType === 'number' ||
                    ruleForm.templateType === 'guiderName'
                "
              >
                <el-form-item label="数据所在行定位" prop="anchorType">
                  <div class="flex">
                  锚点：
                  <el-select
                    clearable
                    class="mr10"
                    size="small"
                    style="width: 150px"
                    v-model="ruleForm.anchorType"
                    placeholder="请选择锚点类型"
                  >
                    <el-option label="条码所在行" value="barcode"></el-option>
                    <el-option label="商品名所在行" value="goods"></el-option>
                    <el-option label="条码或商品名所在行" value="barcodeOrGoods"></el-option>
                  </el-select>
                  相对位置：
                  <!-- <el-select
                    clearable
                    style="width: 150px"
                    class="mr10"
                    size="small"
                    v-model="ruleForm.relativePosition"
                    @change="relativePositionChange"
                    placeholder="请选择相对位置"
                  >
                    <el-option label="上一行" value="up"></el-option>
                    <el-option label="同一行" value="same"></el-option>
                    <el-option label="下一行" value="down"></el-option>
                    <el-option label="小数点行" value="point"></el-option>
                  </el-select> -->
                  <span class="flex flex-center item-center input-number-wrap">
                    <el-input-number v-model="ruleForm.upwardOffsetRange" placeholder="向上偏移范围" size="small" :min="-10" :precision="0" :controls="false"></el-input-number>
                    <span class="mx8">~</span>
                    <el-input-number v-model="ruleForm.downwardOffsetRange" placeholder="向下偏移范围" size="small" :min="-10" :precision="0" :controls="false"></el-input-number>
                  </span>
                  </div>
                </el-form-item>
                <!-- <el-form-item
                  label="所在行中提取"
                  prop="relativeType"
                  v-if="ruleForm.templateType === 'number'"
                >
                  <div>
                    锚点：
                    <el-select
                      clearable
                      class="mr10"
                      size="small"
                      style="width: 150px"
                      v-model="ruleForm.relativeType"
                      placeholder="相对锚点位置类型"
                      @change="relativeTypeChange"
                      :disabled="ruleForm.relativePosition === 'point'"
                    >
                      <el-option
                        label="无（数量在最前面）"
                        value="null"
                      ></el-option>
                      <el-option label="条码" value="barcode"></el-option>
                      <el-option label="商品名" value="goods"></el-option>
                      <el-option label="关键字" value="keyWord"></el-option>
                      <el-option label="小数点" value="point"></el-option>
                    </el-select>
                    <el-input
                      v-if="
                        ruleForm.relativeType === 'keyWord' ||
                          ruleForm.relativeType === 'point'
                      "
                      maxlength="25"
                      size="small"
                      style="width: 150px"
                      clearable
                      :placeholder="
                        ruleForm.relativeType === 'keyWord'
                          ? '请输入关键字'
                          : '请输入连续小数点数'
                      "
                      class="mr10 ipt"
                      v-model.trim="ruleForm.keyWord"
                    ></el-input>
                  </div>
                  <div v-if="ruleForm.relativeType === 'point'">
                    第<el-input
                      maxlength="25"
                      size="small"
                      style="width: 80px"
                      clearable
                      placeholder="
                          请输入连续小数点数
                      "
                      class="ml10 mr10 ipt"
                      @input="filterGt0('rowSeq')"
                      v-model.trim="ruleForm.rowSeq"
                    ></el-input
                    >个小数点后，第<el-input
                      maxlength="25"
                      size="small"
                      style="width: 80px"
                      clearable
                      class="ml10 mr10 ipt"
                      @input="filterGt0('numIndex')"
                      v-model.trim="ruleForm.numIndex"
                    ></el-input
                    >个起
                  </div>
                  <div v-else>
                    相对位置：
                    <el-select
                      clearable
                      class="mr10"
                      style="width: 100px"
                      size="small"
                      v-model="ruleForm.rowSeq"
                      placeholder="相对位置"
                    >
                      <el-option label="左侧" value="left"></el-option>
                      <el-option label="右侧" value="right"></el-option>
                    </el-select>
                    定位 第<el-input
                      maxlength="25"
                      size="small"
                      style="width: 80px"
                      clearable
                      class="mr10 ipt"
                      @input="filterGt0('numIndex')"
                      v-model.trim="ruleForm.numIndex"
                    ></el-input
                    >个起
                  </div>
                </el-form-item> -->
              </div>
              <div v-else>
                <el-form-item label="关键字类型" prop="prefixType" v-if="ruleForm.templateType == 'receiptSn'">
                  <el-radio-group v-model="ruleForm.prefixType">
                    <el-radio :label="'notInclude'">关键字前缀</el-radio>
                    <el-radio :label="'include'">关键字开头</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item :label="ruleForm.prefixType == 'include' ? '以关键字开头' : '关键字前缀'" prop="pasLabels" v-if="ruleForm.templateType !== 'receiptSnDate'">
                  <el-tag
                    :key="tag"
                    v-for="tag in ruleForm.pasLabels"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag)"
                    >{{ tag }}</el-tag
                  >
                  <el-input
                    class="input-new-tag"
                    v-if="inputVisible"
                    v-model.trim="inputValue"
                    ref="saveTagInput"
                    size="small"
                    maxlength="10"
                    clearable
                    placeholder="请输入标签，在10个汉字以内"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm"
                  ></el-input>
                  <el-button
                    v-else
                    class="button-new-tag"
                    size="small"
                    @click="showInput"
                    >+ 关键字</el-button
                  >
                  <span class="form-red">不输入则不限制</span>
                </el-form-item>
                <el-form-item label="关键字后缀" prop="pasLabelsLast" v-if="ruleForm.templateType !== 'receiptSnDate'">
                  <el-tag
                    :key="tag"
                    v-for="tag in ruleForm.pasLabelsLast"
                    closable
                    :disable-transitions="false"
                    @close="handleCloseLast(tag)"
                    >{{ tag }}</el-tag
                  >
                  <el-input
                    class="input-new-tag"
                    v-if="inputVisibleLast"
                    v-model.trim="inputValueLast"
                    ref="saveTagInputLast"
                    size="small"
                    maxlength="10"
                    clearable
                    placeholder="请输入关键字，在10个汉字以内"
                    @keyup.enter.native="handleInputConfirmLast"
                    @blur="handleInputConfirmLast"
                  ></el-input>
                  <el-button
                    v-else
                    class="button-new-tag"
                    size="small"
                    @click="showInputLast"
                    >+ 关键字</el-button
                  >
                  <span class="form-red">不输入则不限制</span>
                </el-form-item>
              </div>
              <div v-if="ruleForm.templateType === 'receiptSnDate'">
                <el-form-item label="从小票号第">
                  <div class="flex">
                    <el-form-item prop="minStrLength">
                      <el-input
                          type="number"
                          maxlength="25"
                          size="small"
                          clearable
                          class="mr10 ipt"
                          style="width: 156px"
                          v-model.trim="ruleForm.minStrLength"
                      ></el-input>
                    </el-form-item>
                    位到第
                    <el-form-item prop="maxStrLength">
                      <el-input
                          type="number"
                          maxlength="25"
                          size="small"
                          clearable
                          class="ml10 ipt"
                          style="width: 156px"
                          v-model.trim="ruleForm.maxStrLength"
                      ></el-input>
                    </el-form-item>
                    位
                  </div>
                </el-form-item>
              </div>
              <el-form-item label="字符长度" v-if="ruleForm.templateType != 'receiptSnDate'">
                <div class="flex">
                  <el-form-item prop="minStrLength">
                    <el-input
                      type="number"
                      maxlength="25"
                      size="small"
                      clearable
                      class="mr10 ipt"
                      style="width: 156px"
                      v-model.trim="ruleForm.minStrLength"
                    ></el-input>
                  </el-form-item>
                  ~
                  <el-form-item prop="maxStrLength">
                    <el-input
                      type="number"
                      maxlength="25"
                      size="small"
                      clearable
                      class="ml10 ipt"
                      style="width: 156px"
                      v-model.trim="ruleForm.maxStrLength"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item label="字符串格式" prop="strDemo"  v-if="ruleForm.templateType != 'receiptSnDate'">
                <el-input
                  v-if="ruleForm.templateType !== 'receiptDate' ||  ruleForm.templateType !== 'receiptSnDate'"
                  style="width: 350px"
                  maxlength="25"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  v-model="ruleForm.strDemo"
                  :placeholder="placeholder"
                ></el-input>
                <el-select
                  v-else
                  clearable
                  class="mr10"
                  size="small"
                  style="width: 350px"
                  v-model="ruleForm.strDemo"
                  placeholder="请选择时间格式1"
                >
                  <el-option
                    label="yyyyMd (例：2021/5/1)"
                    value="yyyyMd"
                  ></el-option>
                  <el-option
                    label="yyyyMdd (例：2021/5/01)"
                    value="yyyyMdd"
                  ></el-option>
                  <el-option
                    label="yyyyMMd (例：2021/05/1)"
                    value="yyyyMMd"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="字符串格式" prop="strDemo"  v-if="ruleForm.templateType === 'receiptSnDate'">
                <el-select
                    clearable
                    class="mr10"
                    size="small"
                    style="width: 350px"
                    v-model="ruleForm.strDemo"
                    placeholder="请选择时间格式"
                >
                  <el-option
                      label="yyyyMd (例：2021/5/1)"
                      value="yyyyMd"
                  ></el-option>
                  <el-option
                      label="yyyyMdd (例：2021/5/01)"
                      value="yyyyMdd"
                  ></el-option>
                  <el-option
                      label="yyyyMMd (例：2021/05/1)"
                      value="yyyyMMd"
                  ></el-option>
                  <el-option
                             label="yyMMdd (例：21/05/01)"
                             value="yyMMdd"
                  ></el-option>
                  <el-option
                             label="yyMdd (例：21/5/01)"
                             value="yyMdd"
                  ></el-option>
                  <el-option
                             label="yyMd (例：21/5/1)"
                             value="yyMd"
                  ></el-option>
                  <el-option
                             label="yyyyMMdd (例：2021/05/01)"
                             value="yyyyMMdd"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="正则表达式">
                <template v-if="ruleForm.templateType === 'number'">
                  <div class="flex item-center" v-for="(item, ind) in regList" :key="ind">
                    <el-input v-model.trim="item.value" class="mr10" style="width: 350px" size="small" placeholder="请输入正则表达式"></el-input>
                    <el-button v-if="ind === 0" @click="handleRegAdd" type="primary" size="small">新增</el-button>
                    <el-button v-if="ind !== 0" @click="handleRegDel(ind)" type="primary" size="small">删除</el-button>
                  </div>
                </template>
                <el-input v-else v-model.trim="ruleForm.regularExtractRule" style="width: 350px" size="small" placeholder="请输入正则表达式"></el-input>
              </el-form-item>
              <el-form-item label="是否允许包含符号" prop="charEnable">
                <el-switch
                  size="mini"
                  v-model="ruleForm.charEnable"
                  active-text="允许"
                  inactive-text="禁止"
                  active-color="#2fc348"
                  inactive-color="#ff0000"
                  active-value="yes"
                  inactive-value="no"
                ></el-switch>
              </el-form-item>
            </div>
            <div v-else>
              <el-form-item label="转人工关键字" prop="keyRepeatList">
                <el-tag
                  :key="tag"
                  v-for="tag in ruleForm.keyRepeatList"
                  closable
                  :disable-transitions="false"
                  @close="handleCloseKey(tag)"
                  >{{ tag }}</el-tag
                >
                <el-input
                  class="input-new-tag"
                  v-if="inputVisibleKey"
                  v-model.trim="inputValueKey"
                  ref="saveTagInputKey"
                  size="small"
                  maxlength="10"
                  clearable
                  placeholder="请输入标签，在10个汉字以内"
                  @keyup.enter.native="handleInputConfirmKey"
                  @blur="handleInputConfirmKey"
                ></el-input>
                <el-button
                  v-else
                  class="button-new-tag"
                  size="small"
                  @click="showInputKey"
                  >+ 关键字</el-button
                >
              </el-form-item>
              <el-form-item label="去重规则" prop="repeatRule">
                <el-select
                  clearable
                  class="mr10"
                  size="small"
                  style="width: 350px"
                  v-model="ruleForm.repeatRule"
                  placeholder="去重规则"
                >
                  <el-option label="小票优先" value="receiptSn"></el-option>
                  <el-option
                    label="小票时间优先"
                    value="receiptDateStr"
                  ></el-option>
                  <el-option label="并行" value="both"></el-option>
                </el-select>
              </el-form-item>
            </div>

            <el-form-item label="小票示例" >
              <el-upload
                class="upload flex"
                ref="eluploadMainPic"
                :limit="1"
                drag
                :data="{ fileDir: 'mall' }"
                :headers="{ 'X-Access-Token': $token }"
                :action="$uploadUrl"
                :onSuccess="uploadMainPicSucc"
                :beforeUpload="beforeUpload"
                :onProgress="uploading"
                :show-file-list="uploadShow"
                v-if="!ruleForm.templateImg"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将图片拖到此处，或
                  <em>点击上传</em>
                </div>
                <!-- <div class="el-upload__tip" slot="tip">
                  <div class="ml10">
                    上传图片注意：
                    <div>
                      1.主图仅可设置一张
                    </div>
                    <div>
                      2.图片尺寸建议750x750
                    </div>
                  </div>
                </div> -->
              </el-upload>
              <div class="priview" v-if="ruleForm.templateImg">
                <img :src="ruleForm.templateImg" alt="主图" />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="handleRemove">删除</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="是否启用" prop="enableState">
              <el-switch
                size="mini"
                v-model="ruleForm.enableState"
                active-text="启用"
                inactive-text="禁用"
                active-color="#2fc348"
                inactive-color="#ff0000"
                active-value="yes"
                inactive-value="no"
              ></el-switch>
              <span class="form-red">关闭状态下直接启用系统默认规则</span>
            </el-form-item>
            <el-form-item label="模板描述" prop="description">
              <el-input
                style="width: 360px"
                type="textarea"
                v-model="ruleForm.description"
                placeholder="多行文本，请输入模板描述"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="flex-1 bg ocrResult p10" v-if="showResult">
            <div class="title">小票OCR识别结果</div>
            <div style="height: 900px" class="ocr">
              <el-scrollbar style="height: 100%" class="page-component__scroll">
                <div
                  v-for="(v, i) in ocrResultList"
                  :key="i"
                  class="mb10 pointer"
                >
                  <div>{{ i + 1 }}. {{ v }}</div>
                </div>
              </el-scrollbar>
            </div>
          </div>
        </div>

        <span slot="footer" class="dialog-footer flex flex-center mt20">
          <el-button @click="view('ruleForm')" size="small" type="primary">
            预 览</el-button
          >
          <el-button
            @click="submitForm('ruleForm')"
            size="small"
            type="primary"
          >
            确 认</el-button
          >
          <el-button size="small" @click="cancel">取 消</el-button>
        </span>
      </el-dialog>

      <!-- 批量新增模板弹框 -->
      <el-dialog
          title="批量新增模板"
          :close-on-click-modal="false"
          :visible.sync="dialogBatchVisible"
          width="1000px"
          :before-close="cancelBatch"
      >
        <hm-step :steps="steps" :step="step" :disabled-jump="true"></hm-step>

        <div v-if="step == 1" class="flex">
          <el-form
              v-if="dialogBatchVisible"
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              :inline="false"
              label-width="130px"
          >
            <el-form-item label="模板类型" prop="templateType">
              <el-select
                  class="mr10"
                  size="small"
                  style="width: 350px"
                  v-model="ruleForm.templateType"
                  placeholder="请选择模板类型"
                  @change="typeChange"
              >
                <el-option label="小票时间戳" value="receiptDateStr"></el-option>
                <el-option label="小票号" value="receiptSn"></el-option>
              </el-select>
            </el-form-item>
            <div v-if="ruleForm.templateType !== 'receiptRepeat'">
              <div>
                <el-form-item label="关键字前缀" prop="pasLabels">
                  <el-tag
                      :key="tag"
                      v-for="tag in ruleForm.pasLabels"
                      closable
                      :disable-transitions="false"
                      @close="handleClose(tag)"
                  >{{ tag }}</el-tag
                  >
                  <el-input
                      class="input-new-tag"
                      v-if="inputVisible"
                      v-model.trim="inputValue"
                      ref="saveTagInput"
                      size="small"
                      maxlength="10"
                      clearable
                      placeholder="请输入标签，在10个汉字以内"
                      @keyup.enter.native="handleInputConfirm"
                      @blur="handleInputConfirm"
                  ></el-input>
                  <el-button
                      v-else
                      class="button-new-tag"
                      size="small"
                      @click="showInput"
                  >+ 关键字</el-button
                  >
                  <span class="form-red">不输入则不限制</span>
                </el-form-item>
                <el-form-item label="关键字后缀" prop="pasLabelsLast">
                  <el-tag
                      :key="tag"
                      v-for="tag in ruleForm.pasLabelsLast"
                      closable
                      :disable-transitions="false"
                      @close="handleCloseLast(tag)"
                  >{{ tag }}</el-tag
                  >
                  <el-input
                      class="input-new-tag"
                      v-if="inputVisibleLast"
                      v-model.trim="inputValueLast"
                      ref="saveTagInputLast"
                      size="small"
                      maxlength="10"
                      clearable
                      placeholder="请输入关键字，在10个汉字以内"
                      @keyup.enter.native="handleInputConfirmLast"
                      @blur="handleInputConfirmLast"
                  ></el-input>
                  <el-button
                      v-else
                      class="button-new-tag"
                      size="small"
                      @click="showInputLast"
                  >+ 关键字</el-button
                  >
                  <span class="form-red">不输入则不限制</span>
                </el-form-item>
              </div>

              <el-form-item label="批量生成长度">
                <div class="flex">
                  <el-form-item prop="minStrLength">
                    <el-input
                        type="number"
                        maxlength="25"
                        size="small"
                        clearable
                        class="mr10 ipt"
                        style="width: 156px"
                        v-model.trim="ruleForm.minStrLength"
                    ></el-input>
                  </el-form-item>
                  ~
                  <el-form-item prop="maxStrLength">
                    <el-input
                        type="number"
                        maxlength="25"
                        size="small"
                        clearable
                        class="ml10 ipt"
                        style="width: 156px"
                        v-model.trim="ruleForm.maxStrLength"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-form-item>

              <!--<el-form-item label="字符串格式" prop="strDemo">
                <el-input
                    v-if="ruleForm.templateType !== 'receiptDate'"
                    style="width: 350px"
                    maxlength="25"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model="ruleForm.strDemo"
                    :placeholder="placeholder"
                ></el-input>
                <el-select
                    v-else
                    clearable
                    class="mr10"
                    size="small"
                    style="width: 350px"
                    v-model="ruleForm.strDemo"
                    placeholder="请选择时间格式"
                >
                  <el-option
                      label="yyyyMd (例：2021/5/1)"
                      value="yyyyMd"
                  ></el-option>
                  <el-option
                      label="yyyyMdd (例：2021/5/01)"
                      value="yyyyMdd"
                  ></el-option>
                  <el-option
                      label="yyyyMMd (例：2021/05/1)"
                      value="yyyyMMd"
                  ></el-option>
                </el-select>
              </el-form-item>-->
            </div>
            <!--<el-form-item label="是否启用" prop="enableState">
              <el-switch
                  size="mini"
                  v-model="ruleForm.enableState"
                  active-text="启用"
                  inactive-text="禁用"
                  active-color="#2fc348"
                  inactive-color="#ff0000"
                  active-value="yes"
                  inactive-value="no"
              ></el-switch>
              <span class="form-red">关闭状态下直接启用系统默认规则</span>
            </el-form-item>-->
           <!-- <el-form-item label="模板描述" prop="description">
              <el-input
                  style="width: 360px"
                  type="textarea"
                  v-model="ruleForm.description"
                  placeholder="多行文本，请输入模板描述"
              ></el-input>
            </el-form-item>-->
          </el-form>
        </div>
        <div v-if="step == 2">
          <el-table
              :data="saveBatchList"
              stripe
              border
              size="small"
              style="width: 100%">
            <el-table-column
                header-align="center"
                align="center"
                prop="templateName"
                label="模板名称">
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="name"
                label="模板类型">
              <template slot-scope="scope">
                <div v-if="scope.row.templateType === 'receiptDateStr'">
                  小票时间戳
                </div>
                <div v-else-if="scope.row.templateType === 'receiptSn'">小票号</div>
              </template>
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="keyPrefix"
                label="模板前缀">
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="keySuffix"
                label="模板后缀">
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="minStrLength"
                label="字符长度">
              <template slot-scope="scope">
                {{ scope.row.minStrLength }} - {{ scope.row.maxStrLength }}
              </template>
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                label="操作">
              <template slot-scope="scope">
                <el-button
                    size="small"
                    type="text"
                    @click="delBatch(scope.$index)"
                >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <span slot="footer" class="dialog-footer flex flex-center mt20">
          <div v-if="step == 1">
             <el-button
                 @click="getSaveBatchList('ruleForm')"
                 size="small"
                 type="primary"
             >
            批量生成</el-button
             >
          </div>
          <div v-if="step == 2">
            <el-button size="small" @click="step = 1">上一步</el-button>
            <el-button
                @click="submitBatchForm('ruleForm')"
                size="small"
                type="primary"
            >
            确 认</el-button
            >
          <el-button size="small" @click="cancelBatch">取 消</el-button>
          </div>

        </span>
      </el-dialog>
    </div>
    <!-- <hm-ocr-template-details
      v-if="dialogVisible"
      :dialogVisible="dialogVisible"
      :type="type"
      @cancel="cancel"
      :id="id"
    >
    </hm-ocr-template-details> -->
  </hm-content>
</template>

<script>
import { unique } from "@/utils/utils";
import HmStep from "@/components/HmStep";
// import HmOcrTemplateDetails from "@/components/HmOcrTemplateDetails";
export default {
  components: {
    HmStep
  },
  data() {
    const strLengt = (rule, val, callback) => {
      /*if (!this.ruleForm.minStrLength || !this.ruleForm.maxStrLength) {
        return callback(new Error("请设置最小长度！"));
      }
      if (!this.ruleForm.maxStrLength) {
        return callback(new Error("请设置最大长度！"));
      }*/
      if (
        this.ruleForm.minStrLength !== "" &&
        this.ruleForm.maxStrLength !== ""
      ) {
        if (Number(this.ruleForm.minStrLength) > Number(this.ruleForm.maxStrLength)) {
          /*let min = JSON.parse(JSON.stringify(this.ruleForm.minStrLength));
          let max = JSON.parse(JSON.stringify(this.ruleForm.maxStrLength));
          this.ruleForm.minStrLength = max;
          this.ruleForm.maxStrLength = min;*/
          return callback(new Error("长度最小值不能大于最大值！"));
        }
      }
      callback();
    };
    const minStrLengtIsNULL = (rule, val, callback) => {
      if (!this.ruleForm.minStrLength) {
        return callback(new Error("请设置最小长度！"));
      }
      callback();
    };
    const maxStrLengtIsNULL = (rule, val, callback) => {
      if (!this.ruleForm.maxStrLength) {
        return callback(new Error("请设置最大长度！"));
      }
      callback();
    };
    const validatoranchorType = (rule, val, callback) => {
      // if (this.ruleForm.upwardOffsetRange == "" || this.ruleForm.upwardOffsetRange == undefined) {
      //   return callback(new Error("请输入向上偏移范围"));
      // }
      // if (this.ruleForm.downwardOffsetRange == "" || this.ruleForm.downwardOffsetRange == undefined) {
      //   return callback(new Error("请输入向下偏移范围"));
      // }
      // callback();
          const upward = this.ruleForm.upwardOffsetRange;
          const downward = this.ruleForm.downwardOffsetRange;

          // 检查是否都为数字
          if (upward === undefined || downward === undefined) {
            return callback(new Error('请输入完整的偏移范围'));
          }

          const isUpwardNegative = upward < 0;
          const isDownwardNegative = downward < 0;

          // 判断两个都为负数的情况（不合法）
          if (isUpwardNegative && isDownwardNegative) {
            return callback(new Error('不允许两个偏移量同时为负数'));
          }

          // 如果一正一负，则判断正数的绝对值是否大于负数的绝对值
          if (isUpwardNegative && !isDownwardNegative) {
            if (Math.abs(upward) >= downward) {
              return callback(new Error('向下偏移量（正数）的绝对值必须大于向上偏移量（负数）的绝对值'));
            }
          } else if (!isUpwardNegative && isDownwardNegative) {
            if (Math.abs(downward) >= upward) {
              return callback(new Error('向上偏移量（正数）的绝对值必须大于向下偏移量（负数）的绝对值'));
            }
          }

          callback();
    };
    const validatorRelativeType = (rule, val, callback) => {
      if (
        this.ruleForm.relativeType === "keyWord" &&
        this.ruleForm.keyWord == ""
      ) {
        return callback(new Error("请输入关键字！"));
      } else {
        if (this.ruleForm.rowSeq == "") {
          return callback(new Error("请选择行相对位置！"));
        }
        if (this.ruleForm.numIndex == "") {
          return callback(new Error("请输入定位数字位置!"));
        }
      }
      callback();
    };
    const validatorRegularExtractRule = (rule, val, callback) => {
      if (this.ruleForm.templateType === "number") {
        for (let item of this.regList) {
          if (!item.value) {
            return callback(new Error("请输入正则表达式"));
          }
        }
      } else {
        if (!val) {
          return callback(new Error("请输入正则表达式"))
        }
      }
      callback();
    }
    return {
      searchCondition: {
        templateType:''
      },
      showResult: false,
      id: "",
      inputValueKey: "",
      inputVisibleKey: false,
      inputValueLast: "",
      inputVisibleLast: false,
      inputValue: "",
      inputVisible: false,
      uploadShow: true,
      isSaving: false,
      placeholder: "例如：2020-12-01 19:00:00",
      allMerchant: [],
      regularMatchDesc:'',
      ruleForm: {
        repeatRule: "",
        charEnable: "no",
        enableState: "no",
        autoEnable: "no",
        keyPrefix: "",
        keySuffix: "",
        strDemo: "",
        maxStrLength: "",
        minStrLength: "",
        templateType: "receiptDate",
        pasLabels: [],
        pasLabelsLast: [],
        keyRepeatList: [],
        keyRepeat: "",
        templateName: "",
        anchorType: "",
        relativePosition: "",
        relativeType: "",
        keyWord: "",
        rowSeq: "",
        numIndex: "",
        templateImg: "",
        description: "",
        prefixType: "notInclude",
        regularExtractRule: "",
        upwardOffsetRange: undefined,
        downwardOffsetRange: undefined,
      },
      rules: {
        templateName: {
          required: true,
          message: "请输入模板名称",
          trigger: "change"
        },
        templateType: {
          required: true,
          message: "请选择模板类型",
          trigger: "change"
        },
        repeatRule: {
          required: true,
          message: "请选择去重规则",
          trigger: "change"
        },
        maxStrLength: [
            {
          validator: strLengt
            },
          {
            validator: maxStrLengtIsNULL
          }
        ],
        minStrLength: [
          {
          validator: strLengt
          },
          {
            validator: minStrLengtIsNULL
          }
        ],
        anchorType: [
          {
            required: true,
            message: "请选择锚点类型",
            trigger: "change"
          },
          {
            required: true,
            validator: validatoranchorType
          }
        ],
        relativeType: [
          {
            required: true,
            message: "请选择相对锚点位置类型",
            trigger: "change"
          },
          {
            required: true,
            validator: validatorRelativeType
          }
        ],
        templateImg: {
          required: true,
          message: "请输入小票示例",
          trigger: "change"
        },
        enableState: {
          required: true
        },
        regularExtractRule: {
          required: true,
          trigger: "change",
          validator: validatorRegularExtractRule
        },
      },
      ocrResultList: [],
      dialogVisible: false,
      title: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      type: "",
      dialogBatchVisible: false,
      ruleBatchForm: {
        repeatRule: "",
        charEnable: "no",
        enableState: "no",
        autoEnable: "no",
        keyPrefix: "",
        keySuffix: "",
        strDemo: "",
        maxStrLength: "",
        minStrLength: "",
        templateType: "receiptDate",
        pasLabels: [],
        pasLabelsLast: [],
        keyRepeatList: [],
        keyRepeat: "",
        templateName: "",
        anchorType: "",
        relativePosition: "",
        relativeType: "",
        keyWord: "",
        rowSeq: "",
        numIndex: "",
        templateImg: "",
        description: ""
      },
      step: 1,
      steps: [
        {
          link: "redEnvelopeTemplate",
          name: "设置条件",
        },
        {
          link: "redEnvelopeTemplate",
          name: "确认生成结果",
        },
      ],
      saveBatchList: [],
      regList: [{ key: 1, value: "" }]
    };
  },
  computed: {},
  watch: {},
  created() {
    this.queryGetEnumData()
  },
  mounted() {
    this.queryList();
  },
  methods: {
async queryGetEnumData() {
  const { result } = await this.$store.dispatch("declareTemplateType");
  this.allMerchant = result;

  this.allMerchant.forEach(item => {
    try {
      // 将 description 字符串解析为对象
      const descriptionObj = JSON.parse(item.description);
      // 判断解析后的对象中是否有 regularMatchDesc 属性
      if (descriptionObj && descriptionObj.regularMatchDesc) {
        item.regularMatchDesc = descriptionObj.regularMatchDesc;
      } else {
        item.regularMatchDesc = '';
      }
       if(this.ruleForm.templateType === item.itemValue) {
          this.regularMatchDesc = item.regularMatchDesc;
        }
    } catch (e) {
      // 如果解析失败，则将 regularMatchDesc 设为空字符串
      item.regularMatchDesc = '';
    }
  });
},

    validatorOffsetRange(rule, value, callback) {
  const upward = this.ruleForm.upwardOffsetRange;
  const downward = this.ruleForm.downwardOffsetRange;

  // 检查是否都为数字
  if (upward === undefined || downward === undefined) {
    return callback(new Error('请输入完整的偏移范围'));
  }

  const isUpwardNegative = upward < 0;
  const isDownwardNegative = downward < 0;

  // 判断是否只有一个负数
  if ((isUpwardNegative && isDownwardNegative) || (!isUpwardNegative && !isDownwardNegative)) {
    return callback(new Error('向上偏移量和向下偏移量必须一正一负'));
  }

  // 判断正数的绝对值是否大于负数的绝对值
  if (isUpwardNegative && Math.abs(upward) >= downward) {
    return callback(new Error('向下偏移量（正数）的绝对值必须大于向上偏移量（负数）的绝对值'));
  } else if (isDownwardNegative && Math.abs(downward) >= upward) {
    return callback(new Error('向上偏移量（正数）的绝对值必须大于向下偏移量（负数）的绝对值'));
  }

  callback();
},
    handleRegAdd() {
      let key = this.regList[this.regList.length - 1].key;
      this.regList.push({ key: key + 1, value: "" });
    },
    handleRegDel(index) {
      this.regList.splice(index, 1);
    },
    delBatch(index) {
      this.saveBatchList.splice(index, 1);
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    relativePositionChange(val) {
      if (val === "point") {
        this.ruleForm.relativeType = val;
      }
    },
    typeChange(val) {
      if (val === "receiptDate") {
        this.placeholder = "例如：2020-12-01 19:00:00";
      } else if (val === "receiptSn") {
        this.placeholder = "输入一个示例小票号，例如：FBD202010512312345";
      } else if (val === "receiptDateStr" || val === "shopName") {
        this.placeholder = "输入一个示例时间戳，例如：20201212121212";
      }
      if (val == "receiptDate") {
        this.ruleForm.strDemo = "";
      }
    
      const foundItem = this.allMerchant.find(item => item.itemValue === val);
      if (foundItem) {
        this.regularMatchDesc = foundItem.regularMatchDesc;
      } else {
        this.regularMatchDesc = '';
      }
    },
    showInputKey() {
      this.inputVisibleKey = true;
      this.$nextTick(() => {
        this.$refs.saveTagInputKey.$refs.input.focus();
      });
    },
    handleInputConfirmKey() {
      let inputValue = this.inputValueKey;
      if (inputValue) {
        this.ruleForm.keyRepeatList.push(inputValue);
        this.ruleForm.keyRepeatList = unique(this.ruleForm.keyRepeatList);
      }
      this.inputVisibleKey = false;
      this.inputValueKey = "";
    },
    handleCloseKey(tag) {
      this.ruleForm.keyRepeatList.splice(
        this.ruleForm.keyRepeatList.indexOf(tag),
        1
      );
    },
    showInputLast() {
      this.inputVisibleLast = true;
      this.$nextTick(() => {
        this.$refs.saveTagInputLast.$refs.input.focus();
      });
    },
    handleInputConfirmLast() {
      let inputValue = this.inputValueLast;
      if (inputValue) {
        this.ruleForm.pasLabelsLast.push(inputValue);
        this.ruleForm.pasLabelsLast = unique(this.ruleForm.pasLabelsLast);
      }
      this.inputVisibleLast = false;
      this.inputValueLast = "";
    },
    handleCloseLast(tag) {
      this.ruleForm.pasLabelsLast.splice(
        this.ruleForm.pasLabelsLast.indexOf(tag),
        1
      );
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.ruleForm.pasLabels.push(inputValue);
        this.ruleForm.pasLabels = unique(this.ruleForm.pasLabels);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    handleClose(tag) {
      this.ruleForm.pasLabels.splice(this.ruleForm.pasLabels.indexOf(tag), 1);
    },
    relativeTypeChange(val) {
      if (val != "keyWord") {
        this.ruleForm.keyWord = "";
      }
      if (val != "point") {
        this.ruleForm.rowSeq = "";
      }
    },
    filterGt0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|[^\d]+/g, "");
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "");
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
      this.ruleForm.id = "";
      this.ruleForm.keyWord = "";
      this.ruleForm.numIndex = "";
      this.ruleForm.rowSeq = "";
      this.ruleForm.relativePosition = "";
      this.ruleForm.minStrLength = "";
      this.ruleForm.maxStrLength = "";
      this.ruleForm.keyRepeatList = [];
      this.ruleForm.pasLabels = [];
      this.ruleForm.pasLabelsLast = [];
      this.showResult = false;
      this.ocrResultList = [];
      this.ruleForm.prefixType = "notInclude";
      this.ruleForm.regularExtractRule = "";
      this.ruleForm.templateImg = "";
      this.ruleForm.upwardOffsetRange = undefined;
      this.ruleForm.downwardOffsetRange = undefined;
      this.regList = [{ key: 1, value: "" }];
      this.$forceUpdate();
    },
    cancel(done) {
      this.resetRuleForm();

      this.dialogVisible = false;
      done()
    },
    resetRuleBatchForm() {
      this.$refs.ruleBatchForm.resetFields();
      this.ruleForm.id = "";
      this.ruleForm.keyWord = "";
      this.ruleForm.numIndex = "";
      this.ruleForm.rowSeq = "";
      this.ruleForm.relativePosition = "";
      this.ruleForm.minStrLength = "";
      this.ruleForm.maxStrLength = "";
      this.ruleForm.keyRepeatList = [];
      this.ruleForm.pasLabels = [];
      this.ruleForm.pasLabelsLast = [];
      this.ruleForm.prefixType = "notInclude";
      this.ruleForm.regularExtractRule = "";
      this.ruleForm.upwardOffsetRange = undefined;
      this.ruleForm.downwardOffsetRange = undefined;
      this.regList = [{ key: 1, value: "" }]
      this.$forceUpdate();
    },
    cancelBatch() {
      this.step = 1;
      this.$nextTick(() => {
        this.resetRuleForm();
        this.dialogBatchVisible = false;
      })
    },
    async view(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        let params = JSON.parse(JSON.stringify(this.ruleForm));
        if (this.ruleForm.templateType === "receiptRepeat") {
          if (params.keyRepeatList.length) {
            params.keyRepeat = params.keyRepeatList.join(",");
          }
        } else {
          if (params.pasLabels.length) {
            params.keyPrefix = params.pasLabels.join(",");
          }
          if (params.pasLabelsLast.length) {
            params.keySuffix = params.pasLabelsLast.join(",");
          }
        }

        const { code, result } = await this.$store.dispatch(
          "redEnvelopeTemplatePreviwe",
          params
        );
        if (code === "0") {
          this.$message({
            type: "success",
            message: "操作成功"
          });
          this.showResult = true;
          this.ocrResultList = result.ocrResultList;
          this.preview = result.preview;
        }
      }
    },
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();

      if (valid) {
        let params = JSON.parse(JSON.stringify(this.ruleForm));
        if (this.ruleForm.templateType === "number") {
          params.regularExtractRule = this.regList
            .filter(item => item.value)
            .map(item => item.value)
            .join("|");
        }

        if (this.ruleForm.templateType === "receiptRepeat") {
          if (params.keyRepeatList.length) {
            params.keyRepeat = params.keyRepeatList.join(",");
          } else {
            params.keyRepeat = "";
          }
        } else {
          if (params.pasLabels.length) {
            params.keyPrefix = params.pasLabels.join(",");
          } else {
            params.keyPrefix = "";
          }
          if (params.pasLabelsLast.length) {
            params.keySuffix = params.pasLabelsLast.join(",");
          } else {
            params.keySuffix = "";
          }
        }

        let name =
          this.type === "add"
            ? "sysReceiptOcrTemplateAdd"
            : "sysReceiptOcrTemplateEdit";

        const { code } = await this.$store.dispatch(name, params);
        if (code === "0") {
          this.$message({
            type: "success",
            message: "操作成功"
          });
          this.dialogVisible = false;
          this.queryList();
          this.resetRuleForm();
        }
      }
    },
    async submitBatchForm(formName) {
      if (!this.saveBatchList || this.saveBatchList.length < 1) {
        this.$message({
          message: "请确认批量添加的模板!",
          type: "warning"
        });
        return;
      }
      await this.$store.dispatch("sysReceiptOcrTemplateAddBatch", this.saveBatchList);
      this.$message({
        type: "success",
        message: "操作成功"
      });
      this.queryList();
      this.step = 1;
      this.$nextTick(() => {
        this.resetRuleForm();
        this.dialogBatchVisible = false;
      })

      },
    //获取批量添加数据
    async getSaveBatchList(formName) {
      const valid = await this.$refs[formName].validate();
      if (!valid) {
        return false;
      }
      let params = JSON.parse(JSON.stringify(this.ruleForm));

      if (this.ruleForm.templateType === "receiptRepeat") {
        if (params.keyRepeatList.length) {
          params.keyRepeat = params.keyRepeatList.join(",");
        } else {
          params.keyRepeat = "";
        }
      } else {
        if (params.pasLabels.length) {
          params.keyPrefix = params.pasLabels.join(",");
        } else {
          this.$message({
            message: "请添加关键字前缀!",
            type: "warning"
          });
          return false;
        }
        if (params.pasLabelsLast.length) {
          params.keySuffix = params.pasLabelsLast.join(",");
        } else {
          params.keySuffix = "";
        }
      }

      console.log("params", params);

      let saveBatchList = [];
      let length = Number(params.maxStrLength) - Number(params.minStrLength);
      for (let i = 0; i <= length; i++) {
        let item = JSON.parse(JSON.stringify(params));
        item.minStrLength = Number(params.minStrLength) + i;
        item.maxStrLength = Number(params.minStrLength) + i;
        item.templateName = item.keyPrefix + "_" + item.minStrLength;
        item.enableState = "yes";
        saveBatchList.push(item);
      }
      console.log("saveBatchList", saveBatchList);
      this.saveBatchList = saveBatchList;
      this.step = 2;

    },
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpg" ||
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "gif";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      //   const limitSize = file.size / 1024 <= 1020;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      //   if (!limitSize) {
      //     this.$message({
      //       message: "上传模板大小不能超过 1M!",
      //       type: "warning"
      //     });
      //   }
      return extension || extension2 || extension3 || extension4;
    },
    handleRemove() {
      this.ruleForm.templateImg = "";
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
      this.isSaving = false;
    },
    // 正在上传
    uploading() {
      this.isSaving = true;
      this.uploadShow = true;
    },
    uploadListDetailError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
    },
    uploadMainPicSucc(jsonData) {
      if (jsonData.code === 0) {
        this.ruleForm.templateImg = jsonData.result;
        this.uploadShow = false;
      }
    },
    async del(row) {
      const result = await this.$confirm("删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        const { code } = await this.$store.dispatch(
          "sysReceiptOcrTemplateDel",
          {
            id: row.id
          }
        );
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryList();
        }
      }
    },
    edit(row) {
      this.title = "编辑模板";
      this.type = "edit";
      this.dialogVisible = true;

      this.id = row.id;
      this.$store
        .dispatch("sysReceiptOcrTemplateDetails", { id: row.id })
        .then(res => {
          if (res.code === "0") {
            for (let key in this.ruleForm) {
              this.ruleForm[key] = res.result[key];
            }
            if (this.ruleForm.templateType === 'number') {
              const list = this.ruleForm.regularExtractRule.split('|')
              this.regList = list.map((item, ind) => {
                return {
                  key: ind + 1,
                  value: item
                }
              })
            }
            if (this.ruleForm.templateType === "receiptRepeat") {
              if (this.ruleForm.keyRepeat !== "0" && this.ruleForm.keyRepeat) {
                this.ruleForm.keyRepeatList = this.ruleForm.keyRepeat.split(
                  ","
                );
              }
              this.ruleForm.pasLabels = [];
              this.ruleForm.pasLabelsLast = [];
            } else {
              if (this.ruleForm.keyPrefix !== "0" && this.ruleForm.keyPrefix) {
                this.ruleForm.pasLabels = this.ruleForm.keyPrefix.split(",");
              } else {
                this.ruleForm.pasLabels = [];
              }

              if (this.ruleForm.keySuffix !== "0" && this.ruleForm.keySuffix) {
                this.ruleForm.pasLabelsLast = this.ruleForm.keySuffix.split(
                  ","
                );
              } else {
                this.ruleForm.pasLabelsLast = [];
              }
              this.ruleForm.keyRepeatList = [];
            }
            this.ruleForm.id = res.result.id;
          }
        });
    },
    add() {
      this.type = "add";
      this.title = "新增模板";
      this.dialogVisible = true;
    },
    addBatch() {
      this.type = "addBatch";
      this.ruleForm.templateType = "receiptDateStr";
      this.dialogBatchVisible = true;
    },
    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "sysReceiptOcrTemplateList",
        params
      );
      if (code === "0") {
        const { records, total } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped>
.priview {
  position: relative;
  width: 375px;
  height: 408px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.bg {
  background: white;
}
.ocrResult {
  // width: 300px;
  height: 800px;
}
.ocr {
  background: rgba(255, 249, 252, 1);
  border: 1px solid rgba(229, 0, 101, 1);
  border-radius: 6px;
}
.mx8 {
  margin: 0 8px;
}
.input-number-wrap {
  .el-input-number {
    width: 120px;
  }
  /deep/ .el-input {
    width: 100%;
  }
}
</style>
